import SocialLinks from '@atoms/SocialLinks/SocialLinks';
import { IAuthor } from '@models/IAuthor';
import AuthorPanel from '@molecules/AuthorPanel/AuthorPanel';
import SoftLoadWrapper from '@molecules/SoftLoadWrapper/SoftLoadWrapper';

const Author = (props: IAuthor) => {
  const { socialLinks = null, socialTitle = '' } = props;

  return (
    <section
      className="pb-13 text-black-100 dark:text-white"
      data-testid="CT-43-Author"
    >
      <SoftLoadWrapper>
        <div className="flex flex-col gap-10 xl:gap-13">
          <AuthorPanel {...props} />

          {!!socialLinks?.length && socialTitle && (
            <SocialLinks
              socialLinks={socialLinks}
              socialTitle={socialTitle}
              dataTestId="CT-43-Author-Social-Links"
            />
          )}
        </div>
      </SoftLoadWrapper>
    </section>
  );
};

export default Author;
